import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Box, Button, Collapse, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
/**
 * This will collapse a long list and allow to expand it by clicking the "expand" button.
 */
export var CollapsedList = function (_a) {
    var list = _a.list, _b = _a.collapseItems, collapseItems = _b === void 0 ? 3 : _b;
    var _c = useState(false), showMore = _c[0], setShowMore = _c[1];
    var listItems = useMemo(function () { return (_jsx(Box, __assign({ display: "flex", flexDirection: "column" }, { children: list === null || list === void 0 ? void 0 : list.map(function (item, index) {
            var _a;
            return (_jsxs(Typography, __assign({ variant: "body2", display: "flex", alignItems: "center", my: 1 }, { children: [item.logo && (_jsx(Avatar, { variant: "square", component: "span", alt: item.name, src: (_a = item.logo) !== null && _a !== void 0 ? _a : '', sx: {
                            width: '24px',
                            height: '24px',
                            marginRight: 2,
                        } })), item.name] }), index));
        }) }))); }, [list]);
    if (!list) {
        return null;
    }
    return (_jsxs(Box, __assign({ display: "flex", flexDirection: "column", justifyContent: "center" }, { children: [_jsx(Collapse, __assign({ in: showMore, collapsedSize: collapseItems * 33 }, { children: listItems })), list.length > collapseItems && (_jsxs(Button, __assign({ onClick: function () { return setShowMore(!showMore); } }, { children: [showMore ? 'Less' : 'More', showMore ? _jsx(ArrowDropUpIcon, {}) : _jsx(ArrowDropDownIcon, {})] })))] })));
};
